"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var amplitude = __importStar(require("@amplitude/analytics-browser"));
var logAmplitudeEvent = function (name, eventData) {
    try {
        amplitude.track(name, eventData);
    }
    catch (e) {
        // console.error('Error sending Amplitude event', e);
    }
};
var events = {
    // Onboarding events
    signInStart: function (event) {
        return logAmplitudeEvent('sign in start', event);
    },
    signInSuccess: function (event) {
        return logAmplitudeEvent('sign in success', event);
    },
    clickAppNoWallet: function () { return logAmplitudeEvent('click app no wallet'); },
    downloadWallet: function (event) {
        return logAmplitudeEvent('click download wallet', event);
    },
    walletLinked: function (event) {
        return logAmplitudeEvent('wallet linked', event);
    },
    // Content events
    viewContent: function (event) {
        return logAmplitudeEvent('view content', event);
    },
    promptNotification: function (event) {
        return logAmplitudeEvent('prompt browser notifications permission', event);
    },
    changeWalletSettings: function (event) {
        return logAmplitudeEvent('change wallet settings', event);
    },
    changeClientSettings: function (event) {
        return logAmplitudeEvent('change client settings', event);
    },
    clickButton: function (event) {
        return logAmplitudeEvent('click button', event);
    },
    openModal: function (event) {
        return logAmplitudeEvent('open modal', event);
    },
    clickDarkMode: function (event) {
        return logAmplitudeEvent('click darkmode', event);
    },
    // welcome page events
    clickWhatsNext: function (event) {
        return logAmplitudeEvent('click whats next', event);
    },
    clickMarketsButton: function () { return logAmplitudeEvent('click markets button'); },
    clickMarketsCoin: function (event) {
        return logAmplitudeEvent('click markets coin', event);
    },
    clickNewsArticle: function (event) {
        return logAmplitudeEvent('click news article', event);
    },
    clickNewsButton: function () { return logAmplitudeEvent('click news button'); },
    clickGetStarted: function (event) {
        return logAmplitudeEvent('click get started', event);
    },
    clickUseCrypto: function (event) {
        return logAmplitudeEvent('click use crypto', event);
    },
    clickSocial: function (event) {
        return logAmplitudeEvent('click social', event);
    },
    // markets page events
    viewDetails: function (event) {
        return logAmplitudeEvent('view details', event);
    },
    clickFilter: function (event) {
        return logAmplitudeEvent('click filter', event);
    },
    // news page events
    clickArticle: function (event) {
        return logAmplitudeEvent('click article', event);
    },
    shareArticle: function (event) {
        return logAmplitudeEvent('share article', event);
    },
    // swap events
    swapEntered: function (event) { return logAmplitudeEvent('swap entered', event); },
    swapQuoteReceived: function (event) {
        return logAmplitudeEvent('quote received', event);
    },
    swapOrderCreated: function (event) {
        return logAmplitudeEvent('order started', event);
    },
    swapOrderCompleted: function (event) {
        return logAmplitudeEvent('order complete', event);
    },
    // verse dex events
    clickAddRpc: function (event) {
        return logAmplitudeEvent('rpc cta clicked', event);
    },
    rpcAdded: function (event) { return logAmplitudeEvent('rpc added', event); },
};
exports.default = events;
